import { Modal, Form, Button } from "react-bootstrap";

const EditClientModal = ({showEditModal, setShowEditModal, editFormData, setEditFormData, handleEditSubmit}) => {
  return (
    <Modal
      show={showEditModal}
      onHide={() => setShowEditModal(false)}
      centered
      backdrop="static"
      dialogClassName="custom-modal"
    >
      <Modal.Header
        closeButton
        style={{
          background: "linear-gradient(90deg, #007bff, #00c6ff)",
          color: "#fff",
        }}
      >
        <Modal.Title>Edit User</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#f9f9f9" }}>
        <Form onSubmit={handleEditSubmit}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold text-primary">Name</Form.Label>
            <Form.Control
              type="text"
              value={editFormData.name}
              onChange={(e) =>
                setEditFormData({ ...editFormData, name: e.target.value })
              }
              required
              style={{ borderRadius: "10px", boxShadow: "0 0 5px #007bff55" }}
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="fw-bold text-primary">Email</Form.Label>
            <Form.Control
              type="email"
              value={editFormData.email}
              onChange={(e) =>
                setEditFormData({ ...editFormData, email: e.target.value })
              }
              required
              style={{ borderRadius: "10px", boxShadow: "0 0 5px #007bff55" }}
            />
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button
              variant="outline-secondary"
              onClick={() => setShowEditModal(false)}
              className="me-2"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              style={{ backgroundColor: "#007bff", borderRadius: "8px" }}
            >
              Save Changes
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditClientModal;
